/**
 * Workspace dropdown / empty-state copy (design reference).
 * Keep in sync with product screenshots; do not change casually.
 *
 * Where this appears: the workspace control in the header is only rendered on
 * "global" app routes (e.g. /home, /stories, /data-connectors). It is hidden on
 * /build/... and /present/... — open /stories or /home to see these strings.
 *
 * After login, no workspace is auto-selected so the trigger shows selectWorkspace
 * until the user picks one from the list.
 */
export const WORKSPACE_UI_LABELS = {
  /** Closed dropdown when no workspace is selected */
  selectWorkspace: "Select workspace",
  /** Primary action in the dropdown panel */
  createNewWorkspace: "+ Create new workspace",
  /** Shown when the workspace list from the API is empty */
  noWorkspacesFound: "No workspaces found",
  /** Inline field when creating from the dropdown */
  newWorkspaceNamePlaceholder: "Workspace name",
  /** Modal (first-time empty state) — same naming as legacy UI */
  popupTitle: "Create Workspace",
  popupNamePlaceholder: "Workspace Name",
  popupDescriptionPlaceholder: "Description",
} as const;
